import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0b565197")

_pushScopeId("data-v-0b565197")
const _hoisted_1 = { class: "p-fluid p-m-2" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-col-6" }
const _hoisted_4 = {
  id: "prefix-input-container",
  class: "p-field"
}
const _hoisted_5 = { class: "p-float-label field-container" }
const _hoisted_6 = {
  for: "prefixForCacheTablesName",
  class: "kn-material-input-label"
}
const _hoisted_7 = { class: "p-field" }
const _hoisted_8 = {
  for: "limitForClean",
  class: "kn-material-input-label small-label"
}
const _hoisted_9 = { class: "p-field" }
const _hoisted_10 = {
  for: "schedulingFullClean",
  class: "kn-material-input-label small-label"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "p-field" }
const _hoisted_13 = {
  for: "lastAccessTtl",
  class: "kn-material-input-label small-label"
}
const _hoisted_14 = { class: "p-field" }
const _hoisted_15 = {
  for: "createAndPersistTimeout",
  class: "kn-material-input-label small-label"
}
const _hoisted_16 = { class: "p-col-6" }
const _hoisted_17 = { class: "p-field" }
const _hoisted_18 = {
  for: "spaceAvailable",
  class: "kn-material-input-label small-label"
}
const _hoisted_19 = { id: "spaceAvailable-hint" }
const _hoisted_20 = { class: "p-field" }
const _hoisted_21 = {
  for: "cacheLimitForStore",
  class: "kn-material-input-label small-label"
}
const _hoisted_22 = { class: "p-field" }
const _hoisted_23 = {
  for: "datasource",
  class: "kn-material-input-label small-label"
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "p-field" }
const _hoisted_26 = {
  for: "sqldbCacheTimeout",
  class: "kn-material-input-label small-label"
}
const _hoisted_27 = { class: "p-field" }
const _hoisted_28 = {
  for: "hazelcastTimeout",
  class: "kn-material-input-label small-label"
}
const _hoisted_29 = { class: "p-field" }
const _hoisted_30 = {
  for: "hazelcastLeaseTime",
  class: "kn-material-input-label small-label"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, { class: "p-m-2" }, {
    header: _withId(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-toolbar-group-right" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.cacheManagement.generalSettings')), 1)
        ]),
        end: _withId(() => [
          _createVNode(_component_Button, {
            class: "kn-button p-button-text p-button-rounded",
            onClick: _ctx.save,
            "data-test": "save-button"
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_Button, {
            class: "kn-button p-button-text p-button-rounded",
            onClick: _ctx.discardChanges,
            "data-test": "reset-button"
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('managers.cacheManagement.discard')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    content: _withId(() => [
      _createVNode("form", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("span", _hoisted_5, [
                _createVNode(_component_InputText, {
                  id: "prefixForCacheTablesName",
                  class: "kn-material-input",
                  type: "text",
                  modelValue: _ctx.settings.prefixForCacheTablesName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.settings.prefixForCacheTablesName = $event)),
                  modelModifiers: { trim: true },
                  "data-test": "prefix-input"
                }, null, 8, ["modelValue"]),
                _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('managers.cacheManagement.prefixForCacheTablesName')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("span", null, [
                _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('managers.cacheManagement.maximumPercentOfCacheCleaningQuota')), 1),
                _createVNode(_component_InputNumber, {
                  id: "limitForClean",
                  inputClass: "kn-material-input",
                  modelValue: _ctx.settings.limitForClean,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.settings.limitForClean = $event)),
                  min: 0,
                  max: 100,
                  useGrouping: false,
                  onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onInputNumberChange('limitForClean', $event.value))),
                  "data-test": "clean-limit-input"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("span", null, [
                _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('managers.cacheManagement.frequencyOfCleaningDaemon')), 1),
                _createVNode(_component_Dropdown, {
                  id: "schedulingFullClean",
                  class: "kn-material-input",
                  modelValue: _ctx.settings.schedulingFullClean,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.settings.schedulingFullClean = $event)),
                  options: _ctx.generalSettingsCardDescriptor.schedulingTypes
                }, {
                  value: _withId((slotProps) => [
                    (slotProps.value)
                      ? (_openBlock(), _createBlock("div", _hoisted_11, [
                          _createVNode("span", null, _toDisplayString(slotProps.value.value), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  option: _withId((slotProps) => [
                    _createVNode("div", null, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t(slotProps.option.label)), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "options"])
              ])
            ]),
            _createVNode("div", _hoisted_12, [
              _createVNode("span", null, [
                _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('managers.cacheManagement.ttlForCachedDataset')), 1),
                _createVNode(_component_InputNumber, {
                  id: "lastAccessTtl",
                  inputClass: "kn-material-input",
                  modelValue: _ctx.settings.lastAccessTtl,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.settings.lastAccessTtl = $event)),
                  useGrouping: false,
                  onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onInputNumberChange('lastAccessTtl', $event.value))),
                  "data-test": "last-access-ttl-input"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createVNode("div", _hoisted_14, [
              _createVNode("span", null, [
                _createVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('managers.cacheManagement.timeToCreateTempTable')), 1),
                _createVNode(_component_InputNumber, {
                  id: "createAndPersistTimeout",
                  inputClass: "kn-material-input",
                  modelValue: _ctx.settings.createAndPersistTimeout,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.settings.createAndPersistTimeout = $event)),
                  useGrouping: false,
                  onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onInputNumberChange('createAndPersistTimeout', $event.value))),
                  "data-test": "timeout-input"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_16, [
            _createVNode("div", _hoisted_17, [
              _createVNode("span", null, [
                _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('managers.cacheManagement.totalBytesAvailableForCache')), 1),
                _createVNode(_component_InputNumber, {
                  id: "spaceAvailable",
                  inputClass: "kn-material-input",
                  modelValue: _ctx.settings.spaceAvailable,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.settings.spaceAvailable = $event)),
                  min: 0,
                  useGrouping: false,
                  onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onInputNumberChange('spaceAvailable', $event.value))),
                  "data-test": "space-available-input"
                }, null, 8, ["modelValue"]),
                _createVNode("small", _hoisted_19, _toDisplayString(_ctx.formatCacheDimension(_ctx.settings.spaceAvailable)), 1)
              ])
            ]),
            _createVNode("div", _hoisted_20, [
              _createVNode("span", null, [
                _createVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('managers.cacheManagement.cacheDimensionSingleDataset')), 1),
                _createVNode(_component_InputNumber, {
                  id: "cacheLimitForStore",
                  inputClass: "kn-material-input",
                  modelValue: _ctx.settings.cacheLimitForStore,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.settings.cacheLimitForStore = $event)),
                  min: 0,
                  max: 100,
                  useGrouping: false,
                  onInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onInputNumberChange('cacheLimitForStore', $event.value))),
                  "data-test": "cache-limit-input"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createVNode("div", _hoisted_22, [
              _createVNode("span", null, [
                _createVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('managers.cacheManagement.targetDatasource')), 1),
                _createVNode(_component_Dropdown, {
                  id: "datasource",
                  class: "kn-material-input",
                  modelValue: _ctx.datasource,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.datasource = $event)),
                  options: _ctx.datasourceOptions
                }, {
                  value: _withId((slotProps) => [
                    (slotProps.value)
                      ? (_openBlock(), _createBlock("div", _hoisted_24, [
                          _createVNode("span", null, _toDisplayString(slotProps.value.label), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  option: _withId((slotProps) => [
                    _createVNode("div", null, [
                      _createVNode("span", null, _toDisplayString(slotProps.option.label), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "options"])
              ])
            ]),
            _createVNode("div", _hoisted_25, [
              _createVNode("span", null, [
                _createVNode("label", _hoisted_26, _toDisplayString(_ctx.$t('managers.cacheManagement.timeToLock')), 1),
                _createVNode(_component_InputNumber, {
                  id: "sqldbCacheTimeout",
                  inputClass: "kn-material-input",
                  modelValue: _ctx.settings.sqldbCacheTimeout,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.settings.sqldbCacheTimeout = $event)),
                  useGrouping: false,
                  onInput: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onInputNumberChange('sqldbCacheTimeout', $event.value))),
                  "data-test": "sqldb-timeout-input"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createVNode("div", _hoisted_27, [
              _createVNode("span", null, [
                _createVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('managers.cacheManagement.hazelcastTimeToLock')), 1),
                _createVNode(_component_InputNumber, {
                  id: "hazelcastTimeout",
                  inputClass: "kn-material-input",
                  modelValue: _ctx.settings.hazelcastTimeout,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.settings.hazelcastTimeout = $event)),
                  useGrouping: false,
                  onInput: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onInputNumberChange('hazelcastTimeout', $event.value))),
                  "data-test": "hazelcast-timeout-input"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createVNode("div", _hoisted_29, [
              _createVNode("span", null, [
                _createVNode("label", _hoisted_30, _toDisplayString(_ctx.$t('managers.cacheManagement.hazelcastTimeToReleaseLock')), 1),
                _createVNode(_component_InputNumber, {
                  id: "hazelcastLeaseTime",
                  inputClass: "kn-material-input",
                  modelValue: _ctx.settings.hazelcastLeaseTime,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.settings.hazelcastLeaseTime = $event)),
                  useGrouping: false,
                  onInput: _cache[19] || (_cache[19] = ($event: any) => (_ctx.onInputNumberChange('hazelcastLeaseTime', $event.value))),
                  "data-test": "hazelcast-lease-time-input"
                }, null, 8, ["modelValue"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
})